import { create } from "zustand";

// Persiste i filtri della pagina Soci tra le navigazioni (es. entri nel dettaglio
// di un socio — crediti/ricevute/ecc. — e torni indietro: i filtri restano).
export interface PartnersFilters {
  search: string;
  partnerType: string;
  active: string;
}

interface PartnersFilterState extends PartnersFilters {
  set: (patch: Partial<PartnersFilters>) => void;
}

export const usePartnersFilterStore = create<PartnersFilterState>((set) => ({
  search: "",
  partnerType: "",
  active: "true",
  set: (patch) => set(patch)
}));
